import Zone from "@insite/client-framework/Components/Zone";
import Hidden from "@insite/mobius/Hidden";
import React, { FC } from "react";

export interface OwnProps {
    contentId: string;
}

type Props = OwnProps;

const TopBar: React.FC<Props> = ({ contentId }) => {
    return (
        <Hidden below="lg">
            <Zone contentId={contentId} zoneName="SecondaryNavigation" />
        </Hidden>
    );
};

export default TopBar;
